import React from 'react';
import { graphql } from "gatsby";
import styled from "@emotion/styled"
import { faTag, faStar } from "@fortawesome/pro-solid-svg-icons";

import ProjectCard from '../../../components/ProjectCard';
import Tag from '../../../components/Tag';

const StyledProjectCard = styled(ProjectCard)`
  flex-direction: column;
`;

const TopContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

const ProjectTitle = styled.h2`
  margin-bottom: 5px;
  font-weight: 100;
  color: white;
`;

const ProjectSubtitle = styled.p`
  margin-bottom: 0px;
  font-weight: 100;
  color: white;
  font-size: 18px;
  font-family: 'futura-pt', sans-serif;
`;

const BottomTag = styled(Tag)`
  margin-right: 10px;
`;

class KatachiProjectCard extends React.Component {
  render() {
    const { info } = this.props;

    return (
      <StyledProjectCard
        onClick={() => window.location = info.url}
        colourOne="#B224EF"
        colourTwo="#7579FF"
        {...this.props}
      >
        <TopContainer>
          <ProjectTitle>形 Katachi</ProjectTitle>
          <ProjectSubtitle>Katachi is a dynamic form builder for iOS written in Swift.</ProjectSubtitle>
        </TopContainer>
        <BottomContainer>
          <BottomTag icon={faTag} text={info.releases.nodes[0].tagName}/>
          <BottomTag icon={faStar} text={info.stargazers.totalCount}/>
        </BottomContainer>
      </StyledProjectCard>
    )
  }
}

export const query = graphql`
  fragment KatachiRepository on GitHub {
    katachi: repository(name: "katachi", owner: "alexcatch") {
      name,
      url,
      stargazers {
        totalCount
      },
      releases(last: 1) {
        nodes {
          tagName
        }
      },
    }
  }
`

export default KatachiProjectCard;